module.exports = __webpack_public_path__ + "static/media/C001.7bf96860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C001.jpg
// module id = 284
// module chunks = 0